<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Gift Cards</h2>
    <div class="gift-card-button-wrapper justify-start">
      <div class="arrow-link">
        <button @click="handleRoute">
          <span class="inter">Back</span>
        </button>
      </div>
    </div>

    <div class="margin-top-4">
      <div
        class="flex items-center justify-between margin-bottom-2 card-header"
      >
        <p class="editorial">Gift Card</p>

        <p class="">Step {{ currentStep }}/2</p>
      </div>
      <div class="trending-container">
        <StepOne @onCompleteStep="onCompleteStep" v-show="currentStep === 1" />
        <StepTwo
          :cardDetails="cardDetails"
          :emailCount="emailCount"
          v-show="currentStep === 2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/internatinalization/i18n'
import StepOne from './EcommerceGiftCardCreate/StepOne.vue'
import StepTwo from './EcommerceGiftCardCreate/StepTwo.vue'
export default {
  name: 'EcommerceGiftCardCreate',
  data() {
    return {
      currentStep: 1,
      loadingCard: true,
      emailCount: 0,
      isModalActive: false,
      cardDetails: {}
    }
  },
  components: {
    StepOne,
    StepTwo
  },

  computed: {
    restrictEmailsTooltip() {
      return `<span><b>Select this option to restrict gift card redemption to only emails listed</b> Gift cards cannot be transferred or redeemed by members whose emails are not listed).</span> `
    },
    isDisabled() {
      if (this.currentStep <= 1) {
        return !this.cardDetails.name || !this.cardDetails.value
      } else {
        return false
      }
    }
  },

  methods: {
    handleRoute() {
      this.currentStep === 1
        ? this.$router.push({ name: 'EcommerceGiftCards' })
        : (this.currentStep = 1)
    },
    onCompleteStep(cardDetails, currentStep, emailCount) {
      this.emailCount = emailCount
      if (currentStep === 1) {
        this.currentStep = 2
      } else {
        this.currentStep = 1
      }
      this.cardDetails = { ...cardDetails }
    },
    sendGiftCard(e, sendCard) {
      this.isModalActive = false
      this.$router.push({ name: 'EcommerceGiftCards' })

      if (sendCard) {
        this.$store.dispatch('notification/pushNotification', {
          type: 'success',
          messages: [i18n.t('ecommerce.action.gitfcards-sent-success')]
        })
      }
    },
    onCreateGiftCard() {
      if (this.currentStep === 1) {
        this.currentStep = 2
        return
      }
      this.isModalActive = true
    }
  },
  created() {
    setTimeout(() => {
      this.loadingCard = false
    }, 2000)
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.justify-end {
  justify-content: end !important;
}

.arrow-link button {
  text-transform: uppercase;
  text-decoration: none;
  font-weight: 400;
  font-size: 0.813rem;
  display: inline-flex;
  width: max-content;
  font-family: 'Inter', sans-serif;
}

.trending-container {
  padding: 1.25rem;
  border: 1px solid $main-6;
  border-radius: 2px;
  margin-bottom: 2rem;
}

.trending-header {
  h4 {
    text-align: left;
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
  }
}

h4 {
  font-family: $editorial;
  font-weight: normal;
}

.card-header {
  .editorial {
    font-size: 1.25rem;
  }

  p {
    font-size: 0.838rem;
  }
}

.card-info {
  text-align: left;
  font-size: 0.838rem;
}

.form-holder {
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  &.textarea {
    align-items: flex-start;

    .form-label {
      width: 20%;
    }
  }

  .form-label {
    width: 15%;
    display: flex;
    flex-direction: column;
    text-align: left;

    p {
      font-size: 0.838rem;
    }

    span {
      font-size: 0.708rem;
      color: rgba(35, 34, 32, 0.5);
    }
  }

  .form-input {
    width: 85%;

    .upload-option-holder {
      &.muted {
        .option-text,
        .option-desc {
          color: #a09c95;
        }
      }

      .option-text {
        display: block;
        margin: 1rem 0;
        text-align: left;
        padding: 0px 5rem;
      }

      .upload-button-holder {
        display: flex;
        align-items: center;
        gap: 1rem;

        .option-desc {
          font-size: 0.773rem;
          font-weight: normal;
        }
      }
    }

    .input-value {
      width: 22%;
    }

    &.textarea-input {
      width: 100%;

      .input-value {
        width: 80% !important;
      }
    }

    input {
      font-weight: 400 !important;
      height: max-content;
    }

    .custom-date-input {
      gap: 0.3rem;
      width: 20%;

      input {
        font-weight: 400 !important;
        height: max-content;
      }

      .divider {
        font-weight: 400;
        color: #232220;
        font-size: 0.9rem;
      }
    }

    .file-details {
      align-items: flex-start;

      .file-name-holder {
        gap: 0.6rem;
        align-items: center;
        font-weight: 600;

        p {
          font-size: 0.838rem;
        }

        button {
          font-size: 0.838rem;
        }
      }

      .file-count {
        font-size: 0.708rem;
        color: #232220;
      }
    }
  }
}

.textarea-input {
  textarea {
    background-color: transparent;
    border: 1px solid #9b9b9b;
    outline: none !important;
    width: 100%;
    padding: 8px;
    font-size: 0.838rem;

    &:focus {
      border: 1px solid #9b9b9b;
    }
  }
}

.restrict-cards {
  p {
    font-size: 0.838rem;
  }
}

.allow-domains .vue-input-tag-wrapper {
  min-width: 40%;
  max-width: max-content;
}

.cta {
  text-align: right;

  &.top-spacing {
    margin-top: 7rem;
  }

  .button-gemnote--small {
    width: auto !important;
    padding: 0 1.5rem;
    height: 2.5rem;
    display: flex;
    margin-left: auto;
    gap: 20px;

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      background: #a09c95;
      color: #f5f2ee;
      border: none;
    }
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

@media (max-width: 425px) {
  .form-holder .form-label {
    width: 30%;
  }

  .form-holder .form-input .upload-option-holder .upload-button-holder {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
}
</style>
